import React, { useEffect, useState } from 'react';
import city from './city';
import { useDispatch, useSelector } from 'react-redux'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { NavLink, useNavigate } from 'react-router-dom';


const ButyNow = () => {

    const { cart } = useSelector(state => state.food)
    const totalamount = useSelector(state => state.food.afterdiscount)


    const navigate = useNavigate()
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [address, setAddress] = useState('')
    const [citys, setCitys] = useState('')
    const [area, setArea] = useState('')

    const proceedData = async (e) => {
        e.preventDefault();


        const res = await fetch('/sells/order', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ name, email, phone, address, citys, area, cart, totalamount })
        });

        if (res.status === 200) {
            alert('Order successfully send to manager')
            navigate('/sells/order/payment')

        } else {
            toast.error('order not send', {
                position: toast.POSITION.TOP_CENTER
            })

        }

    }

    // useEffect(()=>{
    //     dispatch(afterdiscount())
    // },[cart])

    return (
        <div className='container-fluid' style={{ backgroundColor: '' }}>
            <div className='row m-auto' style={{ width: '70%', }} >

                <div className='col-8' style={{
                    margin: '.5rem auto', boxShadow: 'rgba(0, 4, 7, 0.3) 0px 1px 2px 0px, rgba(0, 4, 7, 0.15) 0px 1px 3px 1px', padding: '1rem'
                }}> <p style={{ textAlign: 'center', fontSize: '1.5rem', color: 'green' }}>
                        fill your detail & Order your food
                    </p><hr />
                    <div className=" col- mb-3">
                        <label for="exampleInputEmail1" className="form-label">Name </label>
                        <input
                            onChange={(e) => setName(e.target.value)}
                            required type="text"
                            value={name}
                            className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                            name='name'
                        />

                    </div>

                    <div className=" col- mb-3">
                        <label for="exampleInputEmail1" className="form-label">Email </label>
                        <input
                            onChange={(e) => setEmail(e.target.value)}
                            required type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                            value={email}
                            name='email'
                        />

                    </div>

                    <div className=" col- mb-3">
                        <label for="exampleInputEmail1" className="form-label">Phone Number</label>
                        <input
                            onChange={(e) => setPhone(e.target.value)}
                            required type="text" className="form-control"
                            name='phone'
                            value={phone}
                            id="exampleInputEmail1" aria-describedby="emailHelp" />

                    </div>

                    <div className=" col- mb-3">
                        <label for="exampleInputEmail1" className="form-label">Address </label>
                        <div className="form-floating">
                            <textarea className="form-control"
                                onChange={(e) => setAddress(e.target.value)}
                                placeholder="Write Address....."
                                name='address'
                                value={address}
                                id="floatingTextarea2" style={{ height: "100px" }}></textarea>

                        </div>

                    </div>


                    <div className=" col- mb-3">
                        <label for="exampleInputEmail1" className="form-label">City </label>
                        <select className="form-select"
                            name='cityss'
                            onChange={(e) => setCitys(e.target.value)}
                            aria-label="Default select example">
                            {
                                city.map((c) => {
                                    return <option value={c} >{c}</option>
                                })
                            }
                        </select>
                    </div>


                    <div className=" col- mb-3">
                        <label for="exampleInputEmail1" className="form-label">Area / Colony </label>
                        <input
                            onChange={(e) => setArea(e.target.value)}
                            required type="text" className="form-control"
                            name='area'
                            value={area}
                            id="exampleInputEmail1" aria-describedby="emailHelp" />

                    </div>
                    <NavLink to='/sells/order/payment'>
                        
                            <button
                                onClick={proceedData}
                                required type="submit" className="btn btn-primary" >

                            Procees To Pay ₹{totalamount.toFixed(2)}
                            </button>
                        
                    </NavLink>
                    <ToastContainer />
                </div> 

            </div>
        </div >
    )
}
export default ButyNow; 